import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Tooltip from '@material-ui/core/Tooltip';

import { Range, Handle } from 'rc-slider';
import 'rc-slider/assets/index.css';

const styles = {width: '80%'};

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      title={value}
      placement='top'
      key={'tooltip-' + Math.ceil(Math.random(100) * 1000)}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

class RangeComponent extends React.Component {
  state = {value: []}
  
  onChange(v) {
    this.setState({value: v})
  }

  componentWillMount() {
    const {value} = this.props
    this.setState({value: value})
  }

  onAfterChange(value) {
    const {onAfterChange} = this.props;
    onAfterChange(value)
  }

  render() {
    const { value, label, dots, step, max, min } = this.props;

    return (
      <FormControl component="fieldset">
        <FormLabel>{label} от {value[0]} до {value[1]}</FormLabel>
        <div style={{padding: '10px 10px 0px 8px'}}>
          <Range
            max={max}
            min={min}
            allowCross={false}
            value={this.state.value}
            onChange={(v) => this.onChange(v)}
            onAfterChange={(v) => this.onAfterChange(v)}
            handle={handle}
            dots={dots}
            step={step}
            trackStyle={[{ backgroundColor: 'rgb(45, 125, 175)' }, { backgroundColor: 'rgb(45, 125, 175)'}]}
            handleStyle={[
              { backgroundColor: 'white', borderColor: 'rgb(45, 125, 175)' },
              { backgroundColor: 'white', borderColor: 'rgb(45, 125, 175)' }
            ]}
            //railStyle={{ backgroundColor: 'rgb(45, 125, 175)' }}
          />
        </div>
      </FormControl>
    );
  }
}

RangeComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RangeComponent);



// WEBPACK FOOTER //
// ./src/RangeComponent.js